import packageJson from '../../package.json';

const appName = packageJson.name;
const appVersion = packageJson.version;

export {
    appName,
    appVersion
};
